import { render } from "./ActivityDrawer.vue?vue&type=template&id=67b6a92f&ts=true"
import script from "./ActivityDrawer.vue?vue&type=script&lang=ts"
export * from "./ActivityDrawer.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__